import React from 'react';
import { GenericTableProps } from '../generic-table/utils';
import MobileCardList, { MobileCardListProps } from '../mobile-card-list/mobile-card-list';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import GenericTable from '../generic-table/generic-table';

export function GenericList<T extends object>(props: GenericTableProps<T> & MobileCardListProps<T>) {
    console.log('props = ', props);
    if (!props.rowConfigs || props.rowConfigs.length === 0) {
        return <GenericTable<T> {...(props as GenericTableProps<T>)} />
    }
    return (isDesktop || isTablet) ? <GenericTable<T> {...(props as GenericTableProps<T>)} /> : <MobileCardList<T> {...(props as MobileCardListProps<T>)} />
}

